<div class="form-field criteria-description" *ngIf="description">
  <label i18n>Summary</label>
  <div [innerHTML]="description"></div>
</div>
